import React, { useState, useEffect } from 'react';
import style from "./css/PicksPalace.module.css";
import { apiURL_BACKEND, UserDataInterface, useJustifyUserType } from './Vars';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
interface PicksPalaceProps {

}


interface referrerUsers {
    name: string,
    referrer: string,
    dateJoined: string,
    balance: number,
}

interface pickPost {
    id: number,
    text: string,
    image_url: string,
    date_created: string
}


const PicksPalacePage: React.FC<PicksPalaceProps> = () => {
    const navigate = useNavigate();
    const userType = useJustifyUserType();
    const [downliners, setDownliner] = useState<Array<referrerUsers>>([]);
    const [userData, setUserData] = useState<UserDataInterface>();
    const [picks, setAllPicks] = useState<Array<pickPost>>([]);

    useEffect(() => {


        const res = axios.get(`${apiURL_BACKEND}/getUser/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            var data = res.data;
            console.log(data);

            setUserData({
                username: data.username,
                email: data.email,
                referrer: data.referrer,
                refer_code: data.refer_code,
                date_joined: data.date_joined,
                package: data.package,
                balance: data.balance,
                user_type: data.user_type,
                tme_username:data.tme_username
            })
        });



        axios.get(`${apiURL_BACKEND}/getAllPicks/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            var dummyPick: Array<pickPost> = []
            res.data.map((pick_: any) => {
                let _p: pickPost = {
                    id: pick_.pk,
                    text: pick_.fields.body,
                    image_url: pick_.fields.image,
                    date_created: pick_.fields.date_created
                }
                dummyPick.push(_p)
            })

            setAllPicks(dummyPick);
        }).catch((err) => { })



        // setUserData({
        //     username:res.
        // })
    }, [])



    useEffect(() => {
        const res = axios.get(`${apiURL_BACKEND}/getDownline/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            const transformedData = JSON.parse(res.data.referrers).map((item: any) => ({
                name: item.fields.username,
                referrer: item.fields.referrer.toString(),
                dateJoined: item.fields.date_created,
                balance: item.fields.balance
            }))

            setDownliner(transformedData);
        })
    }, [])

    useEffect(() => { console.log(downliners) }, [downliners]);

    const buyPlan = () => {
        navigate('/Upgrade/');
    }



    const handleReactionClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        const target = e.currentTarget;
        const parent = target.parentElement?.parentElement;
        const labelEl = parent?.getElementsByTagName("label");
        if (labelEl && labelEl.length > 0) {
            labelEl[0].style.display = labelEl[0].style.display == "none" ? "flex" : "none";
        }
    }


    return (
        <>
            <div className={style.picksPalace}>
                {/* <div className={style.pseudoSideNav}>

                </div> */}
                <div className={style.picksPalaceMain}>

                    <div className={style.allPicks}>
                        <div className={style.pickNav}>
                            <div className={style.profileData}>
                                <img src="/media/profile-picture.png" alt="" />
                                <p className={style.profileUsername}>{userData?.username}</p>
                            </div>
                            <form action="" className={style.pickSearchForm}>
                                <div className={style.PicksSearchBar}>
                                    <input type="text" placeholder='Search Your Picks' />
                                    <button>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                            <path d="M21.2333 22.75L14.4083 15.925C13.8667 16.3583 13.2438 16.7014 12.5396 16.9542C11.8354 17.2069 11.0861 17.3333 10.2917 17.3333C8.32361 17.3333 6.65799 16.6517 5.29479 15.2885C3.9316 13.9253 3.25 12.2597 3.25 10.2917C3.25 8.32361 3.9316 6.65799 5.29479 5.29479C6.65799 3.9316 8.32361 3.25 10.2917 3.25C12.2597 3.25 13.9253 3.9316 15.2885 5.29479C16.6517 6.65799 17.3333 8.32361 17.3333 10.2917C17.3333 11.0861 17.2069 11.8354 16.9542 12.5396C16.7014 13.2437 16.3583 13.8667 15.925 14.4083L22.75 21.2333L21.2333 22.75ZM10.2917 15.1667C11.6458 15.1667 12.7969 14.6927 13.7448 13.7448C14.6927 12.7969 15.1667 11.6458 15.1667 10.2917C15.1667 8.9375 14.6927 7.78646 13.7448 6.83854C12.7969 5.89062 11.6458 5.41667 10.2917 5.41667C8.9375 5.41667 7.78646 5.89062 6.83854 6.83854C5.89063 7.78646 5.41667 8.9375 5.41667 10.2917C5.41667 11.6458 5.89063 12.7969 6.83854 13.7448C7.78646 14.6927 8.9375 15.1667 10.2917 15.1667Z" fill="#5F6368" />
                                        </svg>
                                    </button>
                                </div>
                            </form>
                        </div>


                        <div className={style.pickCollections}>

                            {
                                picks.map((pick_) => {
                                    return <>

                                        <div className={style.PickCard}>
                                            <div className={style.PickCardLogo}>
                                                <img src="/media/logo.png" alt="" />

                                            </div>
                                            <div className={style.pickBody}>
                                                {pick_.text}
                                            </div>

                                            <div className={style.pickImages}>
                                                <img src={pick_.image_url} alt="" />
                                            </div>

                                            <div className={style.reactions}>
                                                <div className={style.allReactions}>
                                                    <div className={style.reactionType}>
                                                        <p>👍</p>
                                                        <p>( 0 )</p>
                                                    </div>
                                                    <div className={style.reactionType}>
                                                        <p>❤️</p>
                                                        <p>( 0 )</p>
                                                    </div>

                                                    <div className={style.reactionType}>
                                                        <p>🔥</p>
                                                        <p>( 0 )</p>
                                                    </div>
                                                </div>
                                                <div className={style.reactionButtonContainer}>
                                                    <label htmlFor="">
                                                        <button>👍</button>
                                                        <button>❤️</button>
                                                        <button>🔥</button>
                                                    </label>
                                                    <button onClick={(e) => handleReactionClick(e)}><svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27" fill="none">
                                                        <path d="M13 26.5C11.2708 26.5 9.64583 26.1719 8.125 25.5156C6.60417 24.8594 5.28125 23.9688 4.15625 22.8438C3.03125 21.7188 2.14062 20.3958 1.48438 18.875C0.828125 17.3542 0.5 15.7292 0.5 14C0.5 12.2708 0.828125 10.6458 1.48438 9.125C2.14062 7.60417 3.03125 6.28125 4.15625 5.15625C5.28125 4.03125 6.60417 3.14062 8.125 2.48438C9.64583 1.82812 11.2708 1.5 13 1.5C13.8958 1.5 14.7604 1.58854 15.5938 1.76562C16.4271 1.94271 17.2292 2.19792 18 2.53125V5.34375C17.2708 4.92708 16.4844 4.59896 15.6406 4.35938C14.7969 4.11979 13.9167 4 13 4C10.2292 4 7.86979 4.97396 5.92188 6.92188C3.97396 8.86979 3 11.2292 3 14C3 16.7708 3.97396 19.1302 5.92188 21.0781C7.86979 23.026 10.2292 24 13 24C15.7708 24 18.1302 23.026 20.0781 21.0781C22.026 19.1302 23 16.7708 23 14C23 13.3333 22.9323 12.6875 22.7969 12.0625C22.6615 11.4375 22.4792 10.8333 22.25 10.25H24.9375C25.125 10.8542 25.2656 11.4635 25.3594 12.0781C25.4531 12.6927 25.5 13.3333 25.5 14C25.5 15.7292 25.1719 17.3542 24.5156 18.875C23.8594 20.3958 22.9688 21.7188 21.8438 22.8438C20.7188 23.9688 19.3958 24.8594 17.875 25.5156C16.3542 26.1719 14.7292 26.5 13 26.5ZM23 7.75V5.25H20.5V2.75H23V0.25H25.5V2.75H28V5.25H25.5V7.75H23ZM17.375 12.75C17.8958 12.75 18.3385 12.5677 18.7031 12.2031C19.0677 11.8385 19.25 11.3958 19.25 10.875C19.25 10.3542 19.0677 9.91146 18.7031 9.54688C18.3385 9.18229 17.8958 9 17.375 9C16.8542 9 16.4115 9.18229 16.0469 9.54688C15.6823 9.91146 15.5 10.3542 15.5 10.875C15.5 11.3958 15.6823 11.8385 16.0469 12.2031C16.4115 12.5677 16.8542 12.75 17.375 12.75ZM8.625 12.75C9.14583 12.75 9.58854 12.5677 9.95312 12.2031C10.3177 11.8385 10.5 11.3958 10.5 10.875C10.5 10.3542 10.3177 9.91146 9.95312 9.54688C9.58854 9.18229 9.14583 9 8.625 9C8.10417 9 7.66146 9.18229 7.29688 9.54688C6.93229 9.91146 6.75 10.3542 6.75 10.875C6.75 11.3958 6.93229 11.8385 7.29688 12.2031C7.66146 12.5677 8.10417 12.75 8.625 12.75ZM13 20.875C14.4167 20.875 15.7031 20.474 16.8594 19.6719C18.0156 18.8698 18.8542 17.8125 19.375 16.5H6.625C7.14583 17.8125 7.98438 18.8698 9.14062 19.6719C10.2969 20.474 11.5833 20.875 13 20.875Z" fill="#5F6368" />
                                                    </svg></button>
                                                </div>

                                            </div>
                                        </div>
                                    </>
                                })
                            }


                        </div>

                    </div>

                </div>
            </div>
        </>
    );
};

export default PicksPalacePage;